class FamigliaConfigurator extends HTMLElement {
  constructor() {
    super();
    this.formId = this.dataset.productFormId;
    this.productRoot = this.closest('.product') || document;

    this.charactersContainer = this.querySelector('[data-famiglia-characters-container]');
    this.characterTemplate = this.querySelector('[data-famiglia-character-template]');
    this.countSelect = this.querySelector('[data-famiglia-character-count]');
    this.maxAnimali = parseInt(this.dataset.maxAnimali, 10);
    if (Number.isNaN(this.maxAnimali)) this.maxAnimali = 3;
    this.maxPersone = parseInt(this.dataset.maxPersone, 10);
    if (Number.isNaN(this.maxPersone)) this.maxPersone = 99;
    this.personaggiInclusi = parseInt(this.dataset.personaggiInclusi, 10);
    if (Number.isNaN(this.personaggiInclusi)) this.personaggiInclusi = 99;
    this.fasciaDaPersone = parseInt(this.dataset.fasciaDaPersone, 10);
    if (Number.isNaN(this.fasciaDaPersone)) this.fasciaDaPersone = 0;
    this.fasciaSupplemento = parseInt(this.dataset.fasciaSupplemento, 10);
    if (Number.isNaN(this.fasciaSupplemento)) this.fasciaSupplemento = 0;

    if (this.countSelect) {
      this.countSelect.addEventListener('change', this.onCountChange.bind(this));
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
    }

    this.renderCharacters(this.currentCharacterCount());
    this.updateNamesVisibility();
    this.addOptionHints();
  }

  currentCharacterCount() {
    return this.countSelect ? parseInt(this.countSelect.value, 10) || 0 : 0;
  }

  onCountChange(event) {
    const count = parseInt(event.target.value, 10) || 0;
    this.renderCharacters(count);
    this.updateNamesVisibility();
  }

  onVariantChange() {
    this.updateNamesVisibility();
    this.addOptionHints();
  }

  getNamesOptionInputs() {
    return this.productRoot.querySelectorAll('input[data-option-name="Nomi sopra le teste"]');
  }

  updateNamesVisibility() {
    if (!this.charactersContainer) return;
    const checked = Array.from(this.getNamesOptionInputs()).find((input) => input.checked);
    const showNames = checked ? checked.value.startsWith('Sì') : false;
    this.charactersContainer.querySelectorAll('[data-famiglia-nome-field]').forEach((field) => {
      field.hidden = !showNames;
      field.querySelectorAll('input').forEach((el) => {
        el.disabled = !showNames;
      });
    });
  }

  addOptionHints() {
    const hints = {
      'Nomi sopra le teste': '(+5€)',
      'Cornice': '(legno +5€)',
    };
    Object.entries(hints).forEach(([optionName, hintText]) => {
      const input = this.productRoot.querySelector(`input[data-option-name="${optionName}"]`);
      const fieldset = input ? input.closest('fieldset') : null;
      const legend = fieldset ? fieldset.querySelector('legend') : null;
      if (!legend || legend.querySelector('.famiglia-configurator__hint')) return;
      const span = document.createElement('span');
      span.className = 'famiglia-configurator__hint';
      span.textContent = ' ' + hintText;
      legend.appendChild(span);
    });
  }

  renderCharacters(count) {
    if (!this.charactersContainer || !this.characterTemplate) return;

    this.charactersContainer.innerHTML = '';

    for (let i = 1; i <= count; i++) {
      this.charactersContainer.appendChild(this.buildCharacterFieldset(i));
    }

    this.updateNamesVisibility();
    this.recomputeGadgetCount();
  }

  buildCharacterFieldset(index) {
    const html = this.characterTemplate.innerHTML
      .replaceAll('__INDEX__', index)
      .replaceAll('__FORM_ID__', this.formId);
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html.trim();
    const fieldset = wrapper.firstElementChild;

    const fieldNames = {
      tipo_personaggio: `properties[Personaggio ${index} - Tipo]`,
      nome: `properties[Nome personaggio ${index}]`,
      tipo_animale: `properties[Personaggio ${index} - Tipo animale]`,
      eta: `properties[Personaggio ${index} - Età]`,
      sesso: `properties[Personaggio ${index} - Sesso]`,
      stoffa_colore: `properties[Personaggio ${index} - Colore stoffa]`,
      stoffa_numero: `properties[Personaggio ${index} - Fantasia stoffa]`,
      gadget: `properties[Personaggio ${index} - Gadget]`,
      pantaloni_o_jeans: `properties[Personaggio ${index} - Pantaloni o jeans]`,
      colore_pantaloni: `properties[Personaggio ${index} - Colore pantaloni]`,
      colore_jeans: `properties[Personaggio ${index} - Colore jeans]`,
      papillon_si_no: `properties[Personaggio ${index} - Papillon]`,
      papillon_tipo: `properties[Personaggio ${index} - Tipo papillon]`,
      papillon_preferenze: `properties[Personaggio ${index} - Preferenze papillon]`,
    };

    fieldset.querySelectorAll('[data-field]').forEach((el) => {
      const key = el.dataset.field;
      if (fieldNames[key]) {
        el.setAttribute('name', fieldNames[key]);
      }
      el.setAttribute('form', this.formId);
    });

    const tipoSelect = fieldset.querySelector('[data-field="tipo_personaggio"]');
    const animaleFields = fieldset.querySelector('[data-famiglia-animale-fields]');
    const personaFields = fieldset.querySelector('[data-famiglia-persona-fields]');
    const sessoSelect = fieldset.querySelector('[data-field="sesso"]');
    const femminaFields = fieldset.querySelector('[data-famiglia-femmina-fields]');
    const maschioFields = fieldset.querySelector('[data-famiglia-maschio-fields]');
    const pantaloniToggle = fieldset.querySelector('[data-famiglia-pantaloni-toggle]');
    const pantaloniColorRow = fieldset.querySelector('[data-famiglia-pantaloni-color]');
    const jeansColorRow = fieldset.querySelector('[data-famiglia-jeans-color]');
    const papillonToggle = fieldset.querySelector('[data-famiglia-papillon-toggle]');
    const papillonFields = fieldset.querySelector('[data-famiglia-papillon-fields]');
    const gadgetSelect = fieldset.querySelector('[data-famiglia-gadget-select]');

    const setGroupDisabled = (group, disabled) => {
      if (!group) return;
      group.hidden = disabled;
      group.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = disabled;
      });
    };

    const applyPantaloniToggle = () => {
      if (!pantaloniToggle) return;
      const isPantaloni = pantaloniToggle.value === 'Pantaloni';
      const isJeans = pantaloniToggle.value === 'Jeans';
      setGroupDisabled(pantaloniColorRow, !isPantaloni);
      setGroupDisabled(jeansColorRow, !isJeans);
    };

    const applyPapillonToggle = () => {
      if (!papillonToggle) return;
      const showPapillon = papillonToggle.value === 'Sì';
      setGroupDisabled(papillonFields, !showPapillon);
    };

    const applySesso = () => {
      const isFemmina = sessoSelect.value === 'Femmina';
      const isMaschio = sessoSelect.value === 'Maschio';
      setGroupDisabled(femminaFields, !isFemmina);
      setGroupDisabled(maschioFields, !isMaschio);
      if (isMaschio) {
        applyPantaloniToggle();
        applyPapillonToggle();
      }
      this.recomputeGadgetCount();
    };

    const applyTipo = () => {
      const isAnimale = tipoSelect.value === 'Animale';
      const isPersona = tipoSelect.value === 'Persona';
      setGroupDisabled(animaleFields, !isAnimale);
      setGroupDisabled(personaFields, !isPersona);
      if (isPersona) applySesso();
      this.recomputeGadgetCount();
    };

    if (tipoSelect) tipoSelect.addEventListener('change', applyTipo);
    if (sessoSelect) sessoSelect.addEventListener('change', applySesso);
    if (pantaloniToggle) pantaloniToggle.addEventListener('change', applyPantaloniToggle);
    if (papillonToggle) papillonToggle.addEventListener('change', applyPapillonToggle);
    if (gadgetSelect) gadgetSelect.addEventListener('change', this.recomputeGadgetCount.bind(this));

    applyTipo();

    return fieldset;
  }

  // The hidden "Costi extra" option carries the euro total of every automatic
  // surcharge: €5 per gadget and €3 per animal.
  recomputeGadgetCount() {
    if (!this.charactersContainer) return;

    let gadgets = 0;
    this.charactersContainer.querySelectorAll('[data-famiglia-gadget-select]').forEach((select) => {
      if (!select.disabled && select.value !== 'Nessuno') gadgets++;
    });

    const tipoSelects = [...this.charactersContainer.querySelectorAll('[data-field="tipo_personaggio"]')];
    const animali = tipoSelects.filter((s) => s.value === 'Animale').length;
    const persone = tipoSelects.filter((s) => s.value === 'Persona').length;
    this.enforceAnimalLimit(tipoSelects, animali);
    this.enforcePersonLimit(tipoSelects, persone);

    // Su alcuni prodotti le figure oltre quelle incluse nel prezzo base costano 5€.
    const extra = Math.max(0, this.currentCharacterCount() - this.personaggiInclusi);
    // Fascia di prezzo: dalle N persone in su (animaletti esclusi) un supplemento fisso.
    const fascia = this.fasciaDaPersone > 0 && persone >= this.fasciaDaPersone ? this.fasciaSupplemento : 0;
    this.setGadgetVariant(gadgets * 5 + animali * 3 + extra * 5 + fascia);
  }

  // The price list caps a quadretto at three animals, so once that many are
  // picked the remaining characters can only be people.
  enforceAnimalLimit(tipoSelects, animali) {
    tipoSelects.forEach((select) => {
      const option = select.querySelector('option[value="Animale"]');
      if (option) option.disabled = animali >= this.maxAnimali && select.value !== 'Animale';
    });
  }

  // Alcuni formati ammettono un tetto di persone piu' basso del totale: la
  // Famiglia 25x25 arriva a sette figure, ma al massimo cinque sono persone,
  // percio' con quattro persone restano tre animaletti e con cinque solo due.
  // Raggiunto il tetto di persone, "Persona" non e' piu' scegliibile da nessuna
  // delle schede che non lo hanno gia' scelto (comprese quelle ancora vuote):
  // le figure restanti possono essere solo animaletti.
  enforcePersonLimit(tipoSelects, persone) {
    tipoSelects.forEach((select) => {
      const option = select.querySelector('option[value="Persona"]');
      if (option) option.disabled = persone >= this.maxPersone && select.value !== 'Persona';
    });
  }

  setGadgetVariant(count) {
    // Only the euro-denominated option is targeted: the former counter held a
    // number of gadgets, so matching it here would silently pick a wrong price
    // while the product options are being migrated.
    const inputs = this.productRoot.querySelectorAll('input[data-option-name="Costi extra"]');
    if (!inputs.length) return;
    const target = Array.from(inputs).find((i) => (parseInt(i.value, 10) || 0) === count);
    if (target && !target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('famiglia-configurator', FamigliaConfigurator);
